import { AxiosPromise } from 'axios'
import qs from 'qs'

import { Retailer } from 'types'
import { makeRequest } from 'utils/requests'
import { fromGlobalId } from 'utils/transformations/graphql'

export type DuplicateOrdersType = {
  webOrderLookupIds: String[]
  retailerProfile: Pick<Retailer, 'id' | 'displayName'>
}

type DuplicateOrdersReturnType = {
  success: boolean
}

export const duplicateOrders = ({
  webOrderLookupIds,
  retailerProfile,
}: DuplicateOrdersType): AxiosPromise<DuplicateOrdersReturnType> => {
  const url = '/orders/duplicate_orders'
  const data = {
    orderIds: webOrderLookupIds.map((id: any) => fromGlobalId(id).id),
    orderForAccountId: fromGlobalId(retailerProfile.id).id,
    orderForLabel: retailerProfile.displayName,
  }

  // TODO(ch15462) rebuild endpoint
  return makeRequest({
    headers: {
      Accept: 'application/json, text/javascript, */*; q=0.01',
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    method: 'post',
    url,
    data: qs.stringify(data),
  })
}
